import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { CustomUIService } from 'src/app/core/services/custom-ui.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material/material.module';

import { GoogleMapsModule } from '@angular/google-maps';

@Component({
  selector: 'app-advertisement-banner',
  templateUrl: './advertisement-banner.component.html',
  styleUrls: ['./advertisement-banner.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule, MaterialModule, GoogleMapsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('scroll', [
      state('on', style({ transform: 'translateX(100vw)' })),
      transition('* => *', [style({ transform: 'translateX(100vw)' }), animate(25000, style({ transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class AdvertisementBannerComponent {
  router = inject(Router);
  customUI = inject(CustomUIService);

  advBanner = toSignal(this.customUI.advBanner, { requireSync: true });

  state = 0;

  scrollDone() {
    this.state++;
  }
}
